import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,
    nameOfProductionBusinessActivities,
    contractNumber,
    contractDay,
    dependentUnitName,
    dependentUnitNameTaxId,
    addressWard,
    addressDistrict,
    addressCity,
  },
} = checkout;

const validation = Yup.object().shape({
  [nameOfProductionBusinessActivities.name]: Yup.string().required(
    nameOfProductionBusinessActivities.errorMsg
  ),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxAgencyId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
    .required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [contractNumber.name]: Yup.number().required(contractNumber.errorMsg),
  [contractDay.name]: Yup.number().required(contractDay.errorMsg),
  [dependentUnitName.name]: Yup.string().required(dependentUnitName.errorMsg),
  [dependentUnitNameTaxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, dependentUnitNameTaxId.invalidMsg)
    .required(dependentUnitNameTaxId.errorMsg),
  [addressWard.name]: Yup.number().required(addressWard.errorMsg),
  [addressDistrict.name]: Yup.number().required(addressDistrict.errorMsg),
  [addressCity.name]: Yup.number().required(addressCity.errorMsg),
});

export default validation;
